module.exports = __webpack_public_path__ + "static/icon5-bb405f63ab96f3cbae4afcc96f9a6462.png";